import { render, staticRenderFns } from "./boolean-cell.vue?vue&type=template&id=2037bd3e"
import script from "./boolean-cell.vue?vue&type=script&lang=js"
export * from "./boolean-cell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports